import { z } from 'zod';
import { decodeHtmlEntities } from '@utils/common';
import { bindInputMaker } from '../util.make-input.js';

const audioDropzoneSchema = z.object({
  type: z.literal("Audio"),
  title: z.string().default("").transform(it => decodeHtmlEntities(it)),
  src: z.string()
});
const imageDropzoneSchema = z.object({
  type: z.literal("Image"),
  title: z.string().default("").transform(it => decodeHtmlEntities(it)),
  src: z.string(),
  audioSrc: z.string().nullish().default(null),
  altText: z.string().nullish().default(null)
});
const textDropzoneSchema = z.object({
  type: z.literal("Text"),
  text: z.string().transform(it => decodeHtmlEntities(it))
});
const makeInput = bindInputMaker();
const matchDropzoneInput = makeInput({
  entry: {
    schema: z.object({
      type: z.literal("match-dropzone").default("match-dropzone"),
      tileId: z.string().default("")
    }),
    shouldValidate: node => node.validation.acceptedTileIds.length > 0,
    validate: (node, entry) => node.validation.acceptedTileIds.includes(entry.tileId),
    parseLegacyDetailItem: (item, context) => {
      if (context.relatedTask.taskType === "Match" && typeof item === "number") {
        const typedTask = context.relatedTask;
        const tile = typedTask.__orderedTiles[context.indexInDetails];
        const selectedDropzoneForTile = typedTask.__orderedContent[item];
        if (tile && selectedDropzoneForTile) {
          return [selectedDropzoneForTile.id, {
            type: "match-dropzone",
            tileId: tile.id
          }];
        }
      }
      return undefined;
    }
  },
  schema: z.discriminatedUnion("type", [audioDropzoneSchema, imageDropzoneSchema, textDropzoneSchema]),
  postprocessSchemaInput: (input, context) => {
    return {
      ...input,
      id: `${context.taskId}-${context.index}`,
      nodeType: "match-dropzone-input",
      validation: {
        acceptedTileIds: context.acceptedTileIds
      }
    };
  }
});

export { audioDropzoneSchema, imageDropzoneSchema, matchDropzoneInput, textDropzoneSchema };
//# sourceMappingURL=input.dropzone.js.map
